export enum PositionKey {
  Home1OneClickGeneration = 'home-1-OneClickGeneration',
  Home2HighQualityVideo = 'home-2-HighQualityVideo',
  Home3VirtualHuman = 'home-3-VirtualHuman',
  Home4AIGCEverything = 'home-4-AIGCEverything',
  Home5AllInOne = 'home-5-AllInOne',
  Home6EasyToUse = 'home-6-EasyToUse',
  Home7TonsOfTemplates = 'home-7-TonsOfTemplates',
  Home8BrandSide = 'home-8-BrandSide',
  Home9StartAIGC = 'home-9-StartAIGC',
}

export const SESSION_SOURCE = 'session_source';

export enum AttrKey {
  URL = 'url',
  NAME = 'name',
}
export const OSS_PATH = 'https://official-site.youyan.xyz/youyan/official_site';

export const EN_OSS_PATH = 'https://fe.rendora.ai/youyan/official_site';

export const AnimationLayoutValue = {
  portraitMode: {
    hide: {
      // startTop: 0,
      // endTop: '-10rem',
      startLeft: '59.5rem',
      endLeft: '49.5rem',
      startWidth: '52rem',
      endWidth: '52rem',
    },
    main: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '79rem',
      endLeft: '59.5rem',
      startWidth: '45rem',
      endWidth: '52rem',
    },
    middle: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '79rem',
      endLeft: '59.5rem',
      startWidth: '45rem',
      endWidth: '52rem',
    },
    small: {
      startRight: '33.5rem',
      endRight: '46rem',
      startWidth: '38rem',
      endWidth: '45rem',
    },
    hideMask: {
      startRight: '21rem',
      endRight: '33.5rem',
      startWidth: '31rem',
      endWidth: '38rem',
    },
  },
  landscapeMode: {
    hide: {
      // startTop: 0,
      // endTop: '-10rem',
      startLeft: 0,
      endLeft: '-10rem',
      startWidth: '164.5rem',
      endWidth: '164.5rem',
    },
    main: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '34.75rem',
      endLeft: 0,
      startWidth: '142.25rem',
      endWidth: '164.5rem',
    },
    middle: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '34.75rem',
      endLeft: 0,
      startWidth: '142.25rem',
      endWidth: '164.5rem',
    },
    small: {
      // startTop: '17rem',
      // endTop: '8.5rem',
      startRight: '-19.5rem',
      endRight: '-7rem',
      startWidth: '120rem',
      endWidth: '142.25rem',
    },
    hideMask: {
      startRight: '-32rem',
      endRight: '-19.5rem',
      startWidth: '97.75rem',
      endWidth: '120rem',
    },
  },
  portraitToLandscapeMode: {
    hide: {
      // startTop: 0,
      // endTop: '-10rem',
      startLeft: '59.5rem',
      endLeft: '49.5rem',
      startWidth: '52rem',
      endWidth: '52rem',
    },
    main: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '79rem',
      endLeft: 0,
      startWidth: '45rem',
      endWidth: '164.5rem',
    },
    middle: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '79rem',
      endLeft: 0,
      startWidth: '45rem',
      endWidth: '164.5rem',
    },
    small: {
      // startTop: '17rem',
      // endTop: '8.5rem',
      startRight: '33.5rem',
      endRight: '-7rem',
      startWidth: '38rem',
      endWidth: '142.25rem',
    },
    hideMask: {
      startRight: '21rem',
      endRight: '-19.5rem',
      startWidth: '31rem',
      endWidth: '120rem',
    },
  },
  landscapeToPortraitMode: {
    hide: {
      // startTop: 0,
      // endTop: '-10rem',
      startLeft: 0,
      endLeft: '-10rem',
      startWidth: '164.5rem',
      endWidth: '164.5rem',
    },
    main: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '34.75rem',
      endLeft: '59.5rem',
      startWidth: '142.25rem',
      endWidth: '52rem',
    },
    middle: {
      // startTop: '8.5rem',
      // endTop: 0,
      startLeft: '34.75rem',
      endLeft: '59.5rem',
      startWidth: '142.25rem',
      endWidth: '52rem',
    },
    small: {
      // startTop: '17rem',
      // endTop: '8.5rem',
      startRight: '-19.5rem',
      endRight: '46rem',
      startWidth: '120rem',
      endWidth: '45rem',
    },
    hideMask: {
      startRight: '-32rem',
      endRight: '33.5rem',
      startWidth: '97.75rem',
      endWidth: '38rem',
    },
  },
};

export const tempUserAvatar = 'https://media.xmov.ai/youyan/images/default/personal_logo.jpeg';

export enum MARKDOWN_NAME {
  HELP_CENTER = 'knowledge_base',
  PROJECT_UPDATE = 'release_notes',
}
